import React, { type FunctionComponent } from 'react'
import { EmptyViewReload } from 'legacy/dash-components/empty-view-reload/EmptyViewReload'

export const StoreGroupsLoadError: FunctionComponent = () => (
  <EmptyViewReload
    titleId="settings.storeGroups.error.title"
    bodyId="settings.storeGroups.error.body"
  />
)
